export interface AttachmentInfo {
  attachmentType: AttachmentTypeList;
  AttachmentExtensions: AttachmentExtensions[];
}

export interface AttachmentType {
  AttachmentTypeId: number;
  Name: string;
  ApplicablePurchaseTypeIds: number[];
  IsDuringPendingQuotations: boolean;
}

export interface AttachmentTypeList {
  RO: AttachmentType[],
  CE: AttachmentType[]
}

export interface AttachmentExtensions {
  AttachmentExtensionId: number;
  ExtensionName: string;
}
export interface Attachment {
  MPDocumentNumber: string | null;
  AttachmentId: number | null;
  FileType: string;
  FileName: string;
  ExtensionName: string;
  AttachmentTypeId: number;
  FileSize: string;
  Data: string;
  CreatedOn: Date;
  CreatedBy: string;
  ModifiedOn: Date;
  ModifiedBy: string;
  isDeleted: boolean;
  Strikethrough: boolean;
  filesRemaining?: number;
  PurchaseType?: number;
  IsDuringPendingQuotations: boolean | null;
  IsDIRP: boolean | null;
  IsRestrictedITProductPolicy: boolean | null;
  TaggedItems?: number[];
  RFQNumber?: string | null;
  MPVendorDetailsId?: number | null;
}


export enum AttachmentTypeIdEnum {
  DOCUMENT_TO_VENDOR = 1,
  QUOTATION_FROM_VENDOR = 2,
  SCOPE_OF_WORK = 3,
  INVITATION_TO_TENDER = 4,
  SECTION_CONDITION_TO_TENDER = 5,
  SECTION_CONDITION_TO_CONTRACT = 6,
  SECTION_SCOPE_OF_WORK = 7,
  SECTION_TENDER_RESPONSE_FORM = 8,
  ADDENDUM = 9,
  RECEIPT = 10,
  INVOICE = 11,
  PRIOR_APPROVAL_DOC_FOR_SR = 12,
  SUPPORTING_DOCUMENT = 15,
  SD_APPROVAL = 20,
  BOARD_EXCO_PRE_APPROVED_DOCUMENT = 21,
  QUOTATION = 22,
  DIRP_APPROVAL = 23,
  RESTRICTED_IT_PRODUCT_SD = 24,
  RESTRICTED_IT_PRODUCT_SD_CDO = 27,
}